// ConsultantShareMonthlyTable.jsx — 상담자배분 [월별 실적]의 "사람 × 월" 표 하나 (2026-10-05)
//   칸 = 건수 / 장수 / 배분금. 오른쪽 끝 = 그 해 합계, 맨 아래 = 월 합계, 이번 달 칸 강조. 이름 칸은 옆으로 밀어도 고정.
import React from 'react';
import { M } from './ConsultantShareMonthly.styles';

const HINTS = {
  charged: '계약이 나온 매장의 주인 마케터 — 정산에서 배분금이 빠지는 쪽 · 서비스 포함',
  owner: '상담자를 둔 마케터 — 배분금을 받는 쪽 · 서비스 포함',
  consultant: '콜을 쓴 1:1 직원 · 서비스 제외',
};

function Cell({ cell }) {
  const count = Number(cell?.count || 0);
  const qty = Number(cell?.qty || 0);
  const amount = Number(cell?.amount || 0);
  if (count === 0 && qty === 0 && amount === 0) return <span style={M.cellZero}>-</span>;
  const negative = count < 0 || qty < 0 || amount < 0;
  return (
    <>
      <div style={M.cellCount(negative)}>{count.toLocaleString('ko-KR')}건</div>
      <div style={M.cellQty(negative)}>{qty.toLocaleString('ko-KR', { maximumFractionDigits: 1 })}장</div>
      <div style={M.cellAmount(negative)}>{amount.toLocaleString('ko-KR')}원</div>
    </>
  );
}

export function ConsultantShareMonthlyTable({ table, months, currentYm, compact }) {
  const rows = table?.rows || [];
  // 휴대폰: 처음 열 때 최근 달(오른쪽)이 보이게
  const scrollToLatest = (el) => {
    if (!el || !compact || el.dataset.scrolled) return;
    el.scrollLeft = el.scrollWidth;
    el.dataset.scrolled = '1';
  };
  return (
    <div style={M.section}>
      <div style={M.sectionHead}>
        <span style={M.sectionTitle}>{table.title} × 월</span>
        <span style={M.sectionHint}>{HINTS[table.key] || ''}</span>
      </div>
      {rows.length === 0 ? (
        <div style={M.empty}>이 해에는 내역이 없습니다.</div>
      ) : (
        <div style={M.tableBox} ref={scrollToLatest}>
          <table style={M.table}>
            <thead>
              <tr>
                <th style={M.thName}>{table.title}</th>
                {months.map((ym) => <th key={ym} style={M.th(ym === currentYm)}>{Number(ym.slice(5, 7))}월</th>)}
                <th style={M.thTotal}>합계</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.id}>
                  <td style={M.nameCell(false)}>
                    {row.label}
                    {!row.isActive && <span style={M.retired}>퇴사</span>}
                  </td>
                  {months.map((ym) => (
                    <td key={ym} style={M.td(ym === currentYm, false)}><Cell cell={row.cells?.[ym]} /></td>
                  ))}
                  <td style={M.tdTotal(false)}><Cell cell={row.total} /></td>
                </tr>
              ))}
              <tr>
                <td style={M.nameCell(true)}>월 합계</td>
                {months.map((ym) => (
                  <td key={ym} style={M.td(ym === currentYm, true)}><Cell cell={table.totals?.[ym]} /></td>
                ))}
                <td style={M.tdTotal(true)}><Cell cell={table.grand} /></td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
